/**
 *
 * Asynchronously loads the component for NewTreatmentPage
 *
 */

import loadable from "@loadable/component";

export default loadable(() => import("./NewTreatmentPage"));
